import axios from 'axios'

let user = {}
user.list = params => {
  return axios.get('/sys/user/find', {params})
}
user.delUser = params => {
  return axios.post('/sys/user/dels', params)
}
user.saveUser = params => {
  return axios.post('/sys/user/update', params)
}
user.denyLogin = params => {
  return axios.get('/sys/user/locking', {params})
}
user.findById = params => {
  return axios.get('/sys/user/load',{params})
}
user.resetPwd = params => {
  return axios.get('/sys/user/resetPwd', {params})
}
export default user



// WEBPACK FOOTER //
// ./src/api/user.js